

export var AnimatedRoutes = (routes, options, c) => {
    return   require('./animated-router').AnimatedRoutes(routes,options,c);
}


// WEBPACK FOOTER //
// ./src/components/functional/index.js